{
	"language": {
		"aria": "Изменить язык"
	},
	"placeholder": {
		"title": "Ваш кабинет кандидата уже готовится",
		"body": "Здесь пока ничего нет. Мы отправим вам ссылку по электронной почте, как только всё будет готово."
	},
	"not_found": {
		"title": "Страница не найдена",
		"body": "Проверьте ссылку, по которой вы перешли, или воспользуйтесь ссылкой из вашего письма."
	},
	"error_boundary": {
		"reload": "Перезагрузить страницу"
	},
	"login": {
		"loading": "Загрузка…",
		"title": "Войдите в свой кабинет кандидата",
		"intro": "Введите адрес электронной почты, чтобы увидеть ваши отклики.",
		"email_label": "Адрес электронной почты",
		"email_placeholder": "you@example.com",
		"submit": "Войти",
		"sending": "Отправка…",
		"sent": {
			"title": "Проверьте электронную почту",
			"body": "Если {{email}} совпадает с одним из откликов, ссылка для входа уже в пути.",
			"retry": "Не получили письмо? Проверьте адрес и попробуйте снова"
		},
		"resent": {
			"title": "Мы отправили вам новую ссылку для входа",
			"body": "Срок действия открытой ссылки истёк. Если ваш адрес совпадает с одним из откликов, новая ссылка для входа уже в пути. Она откроет ту же страницу.",
			"request_manually": "Не получили письмо? Запросите новую ссылку"
		},
		"request_error": {
			"throttled": "Слишком много попыток. Пожалуйста, подождите минуту и попробуйте снова.",
			"invalid_email": "Пожалуйста, введите корректный адрес электронной почты.",
			"generic": "Что-то пошло не так. Пожалуйста, попробуйте снова."
		},
		"unknown_organisation": {
			"title": "Страница не найдена",
			"body": "Проверьте ссылку, по которой вы перешли, или воспользуйтесь ссылкой из вашего письма."
		},
		"error": {
			"title": "Что-то пошло не так",
			"body": "Не удалось загрузить эту страницу. Пожалуйста, попробуйте снова через мгновение."
		}
	},
	"organisations": {
		"title": "Ваши отклики",
		"intro": "Выберите компанию, чтобы увидеть отклики, которые вы ей отправили.",
		"count_one": "{{count}} отклик",
		"count_few": "{{count}} отклика",
		"count_many": "{{count}} откликов",
		"count_other": "{{count}} отклика",
		"empty": {
			"title": "Пока нет откликов",
			"body": "Как только вы откликнетесь на вакансию компании, отклик появится здесь."
		},
		"error": "Не удалось загрузить список компаний. Пожалуйста, попробуйте снова через мгновение.",
		"log_out": "Выйти",
		"logging_out": "Выход…"
	},
	"submissions": {
		"title": "Прошлые отклики",
		"back_to_organisations": "Все компании",
		"cv_uploaded": "Резюме загружено",
		"empty": {
			"title": "Пока нет откликов",
			"body": "Отклики, которые вы отправите в компанию {{organisation}}, появятся здесь."
		},
		"error": "Не удалось загрузить ваши отклики. Пожалуйста, попробуйте снова через мгновение.",
		"log_out": "Выйти",
		"logging_out": "Выход…"
	},
	"profile": {
		"link": {
			"title": "Ваш профиль",
			"cv_added": "Резюме добавлено",
			"cv_missing": "Резюме пока нет"
		},
		"back": "Назад к отклику",
		"context": "{{campaign}} · {{organisation}}",
		"contact_consent": "Вы согласны, чтобы с вами связались по этой вакансии.",
		"cv": {
			"title": "Резюме",
			"upload": {
				"title": "Загрузите резюме",
				"drop_hint": "или перетащите его сюда",
				"constraints": "{{types}}, до {{size}} МБ",
				"uploading": "Загрузка {{fileName}}…",
				"done": "Резюме загружено",
				"error_type": "Этот тип файла не поддерживается. Допустимые типы: {{types}}.",
				"error_size": "Файл слишком большой. Максимальный размер — {{size}} МБ."
			},
			"remove": {
				"label": "Удалить {{fileName}}",
				"question": "Удалить {{fileName}}?",
				"consequence": "Работодатель больше не сможет его увидеть. Это действие нельзя отменить.",
				"confirm": "Удалить резюме",
				"cancel": "Отмена",
				"removing": "Удаление…",
				"error": "Не удалось удалить резюме. Попробуйте ещё раз."
			}
		},
		"work_history": {
			"title": "Опыт работы",
			"description": "Расскажите нам о вашем подходящем опыте работы: где вы работали, чем там занимались и как долго там проработали. Вы можете добавить несколько мест работы, если они подходят.",
			"placeholder": "Опишите место работы",
			"input_label": "Сведения о работе",
			"save": "Сохранить",
			"saving": "Сохранение…",
			"cancel": "Отмена",
			"edit": "Изменить",
			"remove": "Удалить",
			"add_another": "Добавить ещё одно место работы",
			"error_empty": "Напишите что-нибудь перед сохранением.",
			"error_limit": "Вы можете добавить не более {{max}} мест работы.",
			"unsaved_changes": "У вас есть несохранённые изменения в опыте работы. Всё равно покинуть страницу и потерять их?",
			"hints": {
				"label": "Сведения об этой работе",
				"included": "указано",
				"missing": "ещё не указано"
			}
		},
		"education": {
			"title": "Образование",
			"description": "Расскажите нам о вашем подходящем образовании: что вы изучали, где и когда. Подходят дипломы, учебные заведения, курсы и сертификаты. Вы можете добавить несколько записей.",
			"placeholder": "Опишите диплом, учебное заведение или курс",
			"input_label": "Сведения об образовании",
			"save": "Сохранить",
			"saving": "Сохранение…",
			"cancel": "Отмена",
			"edit": "Изменить",
			"remove": "Удалить",
			"add_another": "Добавить ещё одно образование",
			"error_empty": "Напишите что-нибудь перед сохранением.",
			"error_limit": "Вы можете добавить не более {{max}} записей об образовании.",
			"unsaved_changes": "У вас есть несохранённые изменения в образовании. Всё равно покинуть страницу и потерять их?"
		},
		"licenses": {
			"title": "Удостоверения и сертификаты",
			"description": "Расскажите нам о ваших удостоверениях и сертификатах, например водительском удостоверении, удостоверении водителя погрузчика или санитарной книжке. Укажите, когда вы его получили и когда истекает срок действия, если он есть. Вы можете добавить несколько записей.",
			"placeholder": "Опишите удостоверение или сертификат",
			"input_label": "Сведения об удостоверении",
			"save": "Сохранить",
			"saving": "Сохранение…",
			"cancel": "Отмена",
			"edit": "Изменить",
			"remove": "Удалить",
			"add_another": "Добавить ещё одно удостоверение",
			"error_empty": "Напишите что-нибудь перед сохранением.",
			"error_limit": "Вы можете добавить не более {{max}} удостоверений.",
			"unsaved_changes": "У вас есть несохранённые изменения в удостоверениях. Всё равно покинуть страницу и потерять их?"
		}
	},
	"submission": {
		"back": "Назад к моим откликам",
		"back_short": "Назад",
		"not_found": {
			"title": "Отклик не найден",
			"body": "Этот отклик не существует или не принадлежит вам."
		},
		"result": {
			"heading": "Экран подтверждения, который вы видели после отклика"
		},
		"summary": {
			"title": "Сводка ваших ответов",
			"submitted_on": "Вы отправили эту форму",
			"submitted_more_than_once": "Вы заполнили эту форму более одного раза. Мы автоматически объединим ваш профиль; отклик ниже — самый последний."
		}
	}
}
